var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#640A55",
    fillRule: "evenodd",
    d: "M13.896 12.632a.894.894 0 0 1 0-1.264l9.842-9.842A.894.894 0 1 0 22.474.262l-9.842 9.842a.894.894 0 0 1-1.264 0L1.526.262A.894.894 0 1 0 .262 1.526l9.842 9.842a.894.894 0 0 1 0 1.264L.262 22.474a.894.894 0 1 0 1.264 1.264l9.842-9.842a.894.894 0 0 1 1.264 0l9.842 9.842a.894.894 0 1 0 1.264-1.264z",
    clipRule: "evenodd"
  })));
};
export default SvgClose;